module.exports = "https://img.zhijierongxing.com/saas/img/mine_menu5.78d4780f.png";